import React from 'react';

const ItemsCards = ({ items, isAdmin, onEdit, onView, onDuplicate }) => {
  return (
    <div className="items-cards-container">
      {items.map((item) => (
        <div key={item.id} className="item-card">
          <div className="card-header">
            <span className="card-part-number">{item.part_number}</span>
            <span className={`card-type-badge ${item.raw_baked?.toLowerCase()}`}>
              {item.raw_baked || '-'}
            </span>
          </div>
          <div className="card-body">
            <h3
              className="card-title clickable-link"
              onClick={() => isAdmin ? onEdit(item) : onView(item)}
            >
              {item.name}
            </h3>
            {item.category_name && (
              <span className="category-badge">
                {item.category_name}
              </span>
            )}
            <div className="card-details">
              <div className="card-detail-item">
                <span className="detail-label">Weight/Pc:</span>
                <span className="detail-value">
                  {item.weight_per_piece ? `${item.weight_per_piece}g` : '-'}
                </span>
              </div>
              <div className="card-detail-item">
                <span className="detail-label">Qty/Case:</span>
                <span className="detail-value">
                  {item.qty_per_case || '-'}
                </span>
              </div>
              <div className="card-detail-item">
                <span className="detail-label">Case Weight:</span>
                <span className="detail-value">
                  {item.case_weight ? `${item.case_weight}kg` : '-'}
                </span>
              </div>
            </div>
          </div>
          <div className="card-footer">
            {isAdmin ? (
              <>
                <button className="card-action-btn edit" onClick={() => onEdit(item)}>
                  Edit
                </button>
                <button className="card-action-btn duplicate" onClick={() => onDuplicate(item)}>
                  Duplicate
                </button>
              </>
            ) : (
              <button className="card-action-btn view" onClick={() => onView(item)}>
                View
              </button>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ItemsCards;
